import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { AdminAuthProvider } from './context/AdminAuthContext'
import router from './router'

import './styles/variables.css'
import './styles/base.css'
import './styles/components.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <AdminAuthProvider>
      <RouterProvider router={router} />
    </AdminAuthProvider>
  </StrictMode>
)
